import request from '@/api/request'

export const queryAllUnreadCount = params => request('messageCenterUnreadMessage', { params, loading: false, returnAll: true })
export const queryNumberByType = params => request('messageCenterNumberByTypeHttp', { params, loading: false })
export const queryMessageList = params => request('messageCenterQueryMessageListHttp', { params, loading: false })
export const setAllIsRead = params => request('messageCenterAllIsReadHttp', { params, loading: false })
export const setNoticeRead = params => request('messageCenterNoticeReadHttp', { params, loading: false })